export const LOCALE_HEADER_NAME = 'x-gacha-locale'
export const LOCALE_COOKIE_NAME = 'gacha-locale'

